module.exports = __webpack_public_path__ + "img/point1.3e74a6a0.png";